import React, { useState } from 'react';
import './CartItemOptionsModal.css';
import PrimaryButtonDark from '../shared/PrimaryButtonDark';

const CartItemOptionsModal = ({ isOpen, onClose, item, onUpdate }) => {
  const [selectedOptions, setSelectedOptions] = useState(item.selectedOptions || {});
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleOptionChange = (optionIndex, value) => {
    setSelectedOptions(prev => ({
      ...prev,
      [optionIndex]: value
    }));
  };

  const handleMultiSelectChange = (optionIndex, choiceIndex, checked) => {
    const currentSelections = selectedOptions[optionIndex] || [];
    const newSelections = checked
      ? [...currentSelections, choiceIndex]
      : currentSelections.filter(i => i !== choiceIndex);

    const option = item.productOptions[optionIndex];
    if (newSelections.length > option.maxSelections) {
      setError(`Je kunt maximaal ${option.maxSelections} keuzes maken voor ${option.name}`);
      return;
    }

    setSelectedOptions(prev => ({
      ...prev,
      [optionIndex]: newSelections
    }));
    setError("");
  };

  const handleSubmit = () => {
    // Validate required options
    const missingRequired = item.productOptions?.some((option, index) => {
      if (!option.required) return false;
      
      if (option.type === 'text') {
        return !selectedOptions[index]?.trim();
      }
      
      if (option.type === 'select') {
        return selectedOptions[index] === undefined;
      }
      
      if (option.type === 'multiselect') {
        return !selectedOptions[index]?.length;
      }
      
      return false;
    });

    if (missingRequired) {
      setError("Vul alle verplichte opties in");
      return;
    }

    onUpdate({
      ...item,
      selectedOptions
    });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-header">
          <h2>{item.name}</h2>
        </div>
        <div className="modal-body">
          <div className="product-options">
            {item.productOptions?.map((option, index) => (
              <div key={index} className="option-group">
                <label>
                  {option.name}
                  {option.required && <span className="required">*</span>}
                </label>
                {option.type === 'select' && (
                  <select
                    value={selectedOptions[index] === undefined ? '' : selectedOptions[index]}
                    onChange={(e) => handleOptionChange(index, parseInt(e.target.value))}
                  >
                    <option value="">Selecteer een optie</option>
                    {option.options.map((choice, choiceIndex) => (
                      <option key={choiceIndex} value={choiceIndex}>
                        {choice.name}
                        {choice.price > 0 && ` (+€${choice.price})`}
                      </option>
                    ))}
                  </select>
                )}
                {option.type === 'multiselect' && (
                  <div className="multiselect-options">
                    {option.options.map((choice, choiceIndex) => (
                      <label key={choiceIndex} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedOptions[index]?.includes(choiceIndex) || false}
                          onChange={(e) => handleMultiSelectChange(index, choiceIndex, e.target.checked)}
                        />
                        {choice.name}
                        {choice.price > 0 && ` (+€${choice.price})`}
                      </label>
                    ))}
                    <p className="max-selections">
                      Maximaal {option.maxSelections} keuzes
                    </p>
                  </div>
                )}
                {option.type === 'text' && (
                  <input
                    type="text"
                    value={selectedOptions[index] || ''}
                    onChange={(e) => handleOptionChange(index, e.target.value)}
                    placeholder="Voer je tekst in"
                  />
                )}
              </div>
            ))}
          </div>
          {error && <p className="error-message">{error}</p>}
        </div>
        <div className="modal-actions">
          <PrimaryButtonDark onClick={handleSubmit}>
            Opties bijwerken
          </PrimaryButtonDark>
        </div>
      </div>
    </div>
  );
};

export default CartItemOptionsModal; 